export const GET_RECOMMENDATION_REQUEST = "RECOMMENDATION_REQUEST";
export const GET_RECOMMENDATION_REQUEST_SUCCEEDED = "RECOMMENDATION_REQUEST_SUCCEEDED";
export const GET_RECOMMENDATION_REQUEST_FAILED = "RECOMMENDATION_REQUEST_FAILED";
